import type { AgentContextValue } from "@/context/agent/types.ts";
import { useContext } from "react";
import { AgentContext } from "@/context/agent/AgentContext.tsx";

export const useAgentHistory = (): AgentContextValue => {
  const ctx = useContext(AgentContext);
  if (ctx === null) {
    throw new Error("useAgentHistory must be used within AgentHistoryProvider");
  }
  return ctx;
};
